function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module mention/mentionui
 */
import { Plugin } from 'ckeditor5/src/core';
import { ButtonView, ContextualBalloon, clickOutsideHandler } from 'ckeditor5/src/ui';
import { Collection, keyCodes, env, Rect, CKEditorError, logWarning } from 'ckeditor5/src/utils';
import { TextWatcher } from 'ckeditor5/src/typing';
import { debounce } from 'lodash-es';
import MentionsView from './ui/mentionsview';
import DomWrapperView from './ui/domwrapperview';
import MentionListItemView from './ui/mentionlistitemview';
var VERTICAL_SPACING = 3; // The key codes that mention UI handles when it is open.

var handledKeyCodes = [keyCodes.arrowup, keyCodes.arrowdown, keyCodes.enter, keyCodes.tab, keyCodes.esc];
/**
 * The mention UI feature.
 *
 * @extends module:core/plugin~Plugin
 */

var MentionUI = /*#__PURE__*/function (_Plugin) {
  _inherits(MentionUI, _Plugin);

  var _super = _createSuper(MentionUI);

  /**
   * @inheritDoc
   */
  function MentionUI(editor) {
    var _this;

    _classCallCheck(this, MentionUI);

    _this = _super.call(this, editor);
    /**
     * The mention view.
     *
     * @type {module:mention/ui/mentionsview~MentionsView}
     * @private
     */

    _this._mentionsView = _this._createMentionView();
    /**
     * Stores mention feeds configurations.
     *
     * @type {Map<String, Object>}
     * @private
     */

    _this._mentionsConfigurations = new Map();
    /**
     * Debounced feed requester. It uses `lodash#debounce` method to delay function call.
     *
     * @private
     * @param {String} marker
     * @param {String} feedText
     * @method
     */

    _this._requestFeedDebounced = debounce(_this._requestFeed, 100);
    editor.config.define('mention', {
      feeds: []
    });
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(MentionUI, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var editor = this.editor;
      /**
       * The contextual balloon plugin instance.
       *
       * @private
       * @member {module:ui/panel/balloon/contextualballoon~ContextualBalloon}
       */

      this._balloon = editor.plugins.get(ContextualBalloon); // Key listener that handles navigation in mention view.

      editor.editing.view.document.on('keydown', function (evt, data) {
        if (isHandledKey(data.keyCode) && _this2._isUIVisible) {
          data.preventDefault();
          evt.stop(); // Required for Enter key overriding.

          if (data.keyCode == keyCodes.arrowdown) {
            _this2._mentionsView.selectNext();
          }

          if (data.keyCode == keyCodes.arrowup) {
            _this2._mentionsView.selectPrevious();
          }

          if (data.keyCode == keyCodes.enter || data.keyCode == keyCodes.tab) {
            _this2._mentionsView.executeSelected();
          }

          if (data.keyCode == keyCodes.esc) {
            _this2._hideUIAndRemoveMarker();
          }
        }
      }, {
        priority: 'highest'
      }); // Required to override the Enter key.
      // Close the dropdown upon clicking outside of the plugin UI.

      clickOutsideHandler({
        emitter: this._mentionsView,
        activator: function activator() {
          return _this2._isUIVisible;
        },
        contextElements: [this._balloon.view.element],
        callback: function callback() {
          return _this2._hideUIAndRemoveMarker();
        }
      });
      var feeds = editor.config.get('mention.feeds');

      var _iterator = _createForOfIteratorHelper(feeds),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mentionDescription = _step.value;
          var feed = mentionDescription.feed;
          var marker = mentionDescription.marker;

          if (!isValidMentionMarker(marker)) {
            /**
             * The marker must be a single character.
             *
             * Correct markers: `'@'`, `'#'`.
             *
             * Incorrect markers: `'$$'`, `'[@'`.
             *
             * See {@link module:mention/mention~MentionConfig}.
             *
             * @error mentionconfig-incorrect-marker
             * @param {String} marker Configured marker
             */
            throw new CKEditorError('mentionconfig-incorrect-marker', null, {
              marker: marker
            });
          }

          var minimumCharacters = mentionDescription.minimumCharacters || 0;
          var feedCallback = typeof feed == 'function' ? feed.bind(this.editor) : createFeedCallback(feed);

          var watcher = this._setupTextWatcherForFeed(marker, minimumCharacters);

          var itemRenderer = mentionDescription.itemRenderer;
          var definition = {
            watcher: watcher,
            marker: marker,
            feedCallback: feedCallback,
            itemRenderer: itemRenderer
          };

          this._mentionsConfigurations.set(marker, definition);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.on('requestFeed:response', function (evt, data) {
        return _this2._handleFeedResponse(data);
      });
      this.on('requestFeed:error', function () {
        return _this2._hideUIAndRemoveMarker();
      });
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(MentionUI.prototype), "destroy", this).call(this); // Destroy created UI components as they are not automatically destroyed (see ckeditor5#1341).


      this._mentionsView.destroy();
    }
    /**
     * Returns true when {@link #_mentionsView} is in the {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon} and it is
     * currently visible.
     *
     * @readonly
     * @protected
     * @type {Boolean}
     */

  }, {
    key: "_isUIVisible",
    get: function get() {
      return this._balloon.visibleView === this._mentionsView;
    }
    /**
     * Creates the {@link #_mentionsView}.
     *
     * @private
     * @returns {module:mention/ui/mentionsview~MentionsView}
     */

  }, {
    key: "_createMentionView",
    value: function _createMentionView() {
      var _this3 = this;

      var locale = this.editor.locale;
      var mentionsView = new MentionsView(locale);
      this._items = new Collection();
      mentionsView.items.bindTo(this._items).using(function (data) {
        var item = data.item,
            marker = data.marker;
        var listItemView = new MentionListItemView(locale);

        var view = _this3._renderItem(item, marker);

        view.delegate('execute').to(listItemView);
        listItemView.children.add(view);
        listItemView.item = item;
        listItemView.marker = marker;
        listItemView.on('execute', function () {
          mentionsView.fire('execute', {
            item: item,
            marker: marker
          });
        });
        return listItemView;
      });
      mentionsView.on('execute', function (evt, data) {
        var editor = _this3.editor;
        var model = editor.model;
        var item = data.item;
        var marker = data.marker;
        var mentionMarker = editor.model.markers.get('mention'); // Create a range on matched text.

        var end = model.createPositionAt(model.document.selection.focus);
        var start = model.createPositionAt(mentionMarker.getStart());
        var range = model.createRange(start, end);

        _this3._hideUIAndRemoveMarker();

        editor.execute('mention', {
          mention: item,
          text: item.text,
          marker: marker,
          range: range
        });
        editor.editing.view.focus();
      });
      return mentionsView;
    }
    /**
     * Returns item renderer for the marker.
     *
     * @private
     * @param {String} marker
     * @returns {Function|null}
     */

  }, {
    key: "_getItemRenderer",
    value: function _getItemRenderer(marker) {
      var _this$_mentionsConfig = this._mentionsConfigurations.get(marker),
          itemRenderer = _this$_mentionsConfig.itemRenderer;

      return itemRenderer;
    }
    /**
     * Requests a feed from a configured callbacks.
     *
     * @private
     * @fires module:mention/mentionui~MentionUI#event:requestFeed:response
     * @fires module:mention/mentionui~MentionUI#event:requestFeed:discarded
     * @fires module:mention/mentionui~MentionUI#event:requestFeed:error
     * @param {String} marker
     * @param {String} feedText
     */

  }, {
    key: "_requestFeed",
    value: function _requestFeed(marker, feedText) {
      var _this4 = this;

      // Store the last requested feed - it is used to discard any out-of order requests.
      this._lastRequested = feedText;

      var _this$_mentionsConfig2 = this._mentionsConfigurations.get(marker),
          feedCallback = _this$_mentionsConfig2.feedCallback;

      var feedResponse = feedCallback(feedText);
      var isAsynchronous = feedResponse instanceof Promise; // For synchronous feeds (e.g. callbacks, arrays) fire the response event immediately.

      if (!isAsynchronous) {
        /**
         * Fired whenever requested feed has a response.
         *
         * @event requestFeed:response
         * @param {Object} data Event data.
         * @param {Array.<module:mention/mention~MentionFeedItem>} data.feed Autocomplete items.
         * @param {String} data.marker The character which triggers autocompletion for mention.
         * @param {String} data.feedText The text for which feed items were requested.
         */
        this.fire('requestFeed:response', {
          feed: feedResponse,
          marker: marker,
          feedText: feedText
        });
        return;
      } // Handle the asynchronous responses.


      feedResponse.then(function (response) {
        // Check the feed text of this response with the last requested one so either:
        if (_this4._lastRequested == feedText) {
          // It is the same and fire the response event.
          _this4.fire('requestFeed:response', {
            feed: response,
            marker: marker,
            feedText: feedText
          });
        } else {
          // It is different - most probably out-of-order one, so fire the discarded event.

          /**
           * Fired whenever the requested feed was discarded. This happens when the response was delayed and
           * other feed was already requested.
           *
           * @event requestFeed:discarded
           * @param {Object} data Event data.
           * @param {Array.<module:mention/mention~MentionFeedItem>} data.feed Autocomplete items.
           * @param {String} data.marker The character which triggers autocompletion for mention.
           * @param {String} data.feedText The text for which feed items were requested.
           */
          _this4.fire('requestFeed:discarded', {
            feed: response,
            marker: marker,
            feedText: feedText
          });
        }
      }).catch(function (error) {
        /**
         * Fired whenever the requested {@link module:mention/mention~MentionFeed#feed} promise fails with error.
         *
         * @event requestFeed:error
         * @param {Object} data Event data.
         * @param {Error} data.error The error that was caught.
         */
        _this4.fire('requestFeed:error', {
          error: error
        });
        /**
         * The callback used for obtaining mention autocomplete feed thrown and error and the mention UI was hidden or
         * not displayed at all.
         *
         * @error mention-feed-callback-error
         * @param {String} marker Configured marker for which error occurred.
         */


        logWarning('mention-feed-callback-error', {
          marker: marker
        });
      });
    }
    /**
     * Registers a text watcher for the marker.
     *
     * @private
     * @param {String} marker
     * @param {Number} minimumCharacters
     * @returns {module:typing/textwatcher~TextWatcher}
     */

  }, {
    key: "_setupTextWatcherForFeed",
    value: function _setupTextWatcherForFeed(marker, minimumCharacters) {
      var _this5 = this;

      var editor = this.editor;
      var watcher = new TextWatcher(editor.model, createTestCallback(marker, minimumCharacters));
      watcher.on('matched', function (evt, data) {
        var selection = editor.model.document.selection;
        var focus = selection.focus;

        if (hasExistingMention(focus)) {
          _this5._hideUIAndRemoveMarker();

          return;
        }

        var feedText = requestFeedText(marker, data.text);
        var matchedTextLength = marker.length + feedText.length; // Create a marker range.

        var start = focus.getShiftedBy(-matchedTextLength);
        var end = focus.getShiftedBy(-feedText.length);
        var markerRange = editor.model.createRange(start, end);

        if (checkIfStillInCompletionMode(editor)) {
          var mentionMarker = editor.model.markers.get('mention'); // Update the marker - user might've moved the selection to other mention trigger.

          editor.model.change(function (writer) {
            writer.updateMarker(mentionMarker, {
              range: markerRange
            });
          });
        } else {
          editor.model.change(function (writer) {
            writer.addMarker('mention', {
              range: markerRange,
              usingOperation: false,
              affectsData: false
            });
          });
        }

        _this5._requestFeedDebounced(marker, feedText);
      });
      watcher.on('unmatched', function () {
        _this5._hideUIAndRemoveMarker();
      });
      var mentionCommand = editor.commands.get('mention');
      watcher.bind('isEnabled').to(mentionCommand);
      return watcher;
    }
    /**
     * Handles the feed response event data.
     *
     * @param data
     * @private
     */

  }, {
    key: "_handleFeedResponse",
    value: function _handleFeedResponse(data) {
      var feed = data.feed,
          marker = data.marker; // If the marker is not in the document happens when the selection had changed and the 'mention' marker was removed.

      if (!checkIfStillInCompletionMode(this.editor)) {
        return;
      } // Reset the view.


      this._items.clear();

      var _iterator2 = _createForOfIteratorHelper(feed),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var feedItem = _step2.value;
          var item = _typeof(feedItem) != 'object' ? {
            id: feedItem,
            text: feedItem
          } : feedItem;

          this._items.add({
            item: item,
            marker: marker
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var mentionMarker = this.editor.model.markers.get('mention');

      if (this._items.length) {
        this._showOrUpdateUI(mentionMarker);
      } else {
        // Do not show empty mention UI.
        this._hideUIAndRemoveMarker();
      }
    }
    /**
     * Shows the mentions balloon. If the panel is already visible, it will reposition it.
     *
     * @private
     */

  }, {
    key: "_showOrUpdateUI",
    value: function _showOrUpdateUI(markerMarker) {
      if (this._isUIVisible) {
        // Update balloon position as the mention list view may change its size.
        this._balloon.updatePosition(this._getBalloonPanelPositionData(markerMarker, this._mentionsView.position));
      } else {
        this._balloon.add({
          view: this._mentionsView,
          position: this._getBalloonPanelPositionData(markerMarker, this._mentionsView.position),
          withArrow: false,
          singleViewMode: true
        });
      }

      this._mentionsView.position = this._balloon.view.position;

      this._mentionsView.selectFirst();
    }
    /**
     * Hides the mentions balloon and removes the 'mention' marker from the markers collection.
     *
     * @private
     */

  }, {
    key: "_hideUIAndRemoveMarker",
    value: function _hideUIAndRemoveMarker() {
      // Remove the mention view from balloon before removing marker - it is used by balloon position target().
      if (this._balloon.hasView(this._mentionsView)) {
        this._balloon.remove(this._mentionsView);
      }

      if (checkIfStillInCompletionMode(this.editor)) {
        this.editor.model.change(function (writer) {
          return writer.removeMarker('mention');
        });
      } // Make the last matched position on panel view undefined so the #_getBalloonPanelPositionData() method will return all positions
      // on the next call.


      this._mentionsView.position = undefined;
    }
    /**
     * Renders a single item in the autocomplete list.
     *
     * @private
     * @param {module:mention/mention~MentionFeedItem} item
     * @param {String} marker
     * @returns {module:ui/button/buttonview~ButtonView|module:mention/ui/domwrapperview~DomWrapperView}
     */

  }, {
    key: "_renderItem",
    value: function _renderItem(item, marker) {
      var editor = this.editor;
      var view;
      var label = item.id;

      var renderer = this._getItemRenderer(marker);

      if (renderer) {
        var renderResult = renderer(item);

        if (typeof renderResult != 'string') {
          view = new DomWrapperView(editor.locale, renderResult);
        } else {
          label = renderResult;
        }
      }

      if (!view) {
        var buttonView = new ButtonView(editor.locale);
        buttonView.label = label;
        buttonView.withText = true;
        view = buttonView;
      }

      return view;
    }
    /**
     * Creates a position options object used to position the balloon panel.
     *
     * @param {module:engine/model/markercollection~Marker} mentionMarker
     * @param {String|undefined} preferredPosition The name of the last matched position name.
     * @returns {module:utils/dom/position~Options}
     * @private
     */

  }, {
    key: "_getBalloonPanelPositionData",
    value: function _getBalloonPanelPositionData(mentionMarker, preferredPosition) {
      var _this6 = this;

      var editor = this.editor;
      var editing = editor.editing;
      var domConverter = editing.view.domConverter;
      var mapper = editing.mapper;
      return {
        target: function target() {
          var modelRange = mentionMarker.getRange(); // Target the UI to the model selection range - the marker has been removed so probably the UI will not be shown anyway.
          // The logic is used by ContextualBalloon to display another panel in the same place.

          if (modelRange.start.root.rootName == '$graveyard') {
            modelRange = editor.model.document.selection.getFirstRange();
          }

          var viewRange = mapper.toViewRange(modelRange);
          var rangeRects = Rect.getDomRangeRects(domConverter.viewRangeToDom(viewRange));
          return rangeRects.pop();
        },
        limiter: function limiter() {
          var view = _this6.editor.editing.view;
          var viewDocument = view.document;
          var editableElement = viewDocument.selection.editableElement;

          if (editableElement) {
            return view.domConverter.mapViewToDom(editableElement.root);
          }

          return null;
        },
        positions: getBalloonPanelPositions(preferredPosition)
      };
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'MentionUI';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [ContextualBalloon];
    }
  }]);

  return MentionUI;
}(Plugin); // Returns the balloon positions data callbacks.
//
// @param {String} preferredPosition
// @returns {Array.<module:utils/dom/position~Position>}


export { MentionUI as default };

function getBalloonPanelPositions(preferredPosition) {
  var positions = {
    // Positions the panel to the southeast of the caret rectangle.
    'caret_se': function caret_se(targetRect) {
      return {
        top: targetRect.bottom + VERTICAL_SPACING,
        left: targetRect.right,
        name: 'caret_se'
      };
    },
    // Positions the panel to the northeast of the caret rectangle.
    'caret_ne': function caret_ne(targetRect, balloonRect) {
      return {
        top: targetRect.top - balloonRect.height - VERTICAL_SPACING,
        left: targetRect.right,
        name: 'caret_ne'
      };
    },
    // Positions the panel to the southwest of the caret rectangle.
    'caret_sw': function caret_sw(targetRect, balloonRect) {
      return {
        top: targetRect.bottom + VERTICAL_SPACING,
        left: targetRect.right - balloonRect.width,
        name: 'caret_sw'
      };
    },
    // Positions the panel to the northwest of the caret rect.
    'caret_nw': function caret_nw(targetRect, balloonRect) {
      return {
        top: targetRect.top - balloonRect.height - VERTICAL_SPACING,
        left: targetRect.right - balloonRect.width,
        name: 'caret_nw'
      };
    }
  }; // Returns only the last position if it was matched to prevent the panel from jumping after the first match.

  if (Object.prototype.hasOwnProperty.call(positions, preferredPosition)) {
    return [positions[preferredPosition]];
  } // By default return all position callbacks.


  return [positions.caret_se, positions.caret_sw, positions.caret_ne, positions.caret_nw];
} // Creates a RegExp pattern for the marker.
//
// Function has to be exported to achieve 100% code coverage.
//
// @param {String} marker
// @param {Number} minimumCharacters
// @returns {RegExp}


export function createRegExp(marker, minimumCharacters) {
  var numberOfCharacters = minimumCharacters == 0 ? '*' : "{".concat(minimumCharacters, ",}");
  var openAfterCharacters = env.features.isRegExpUnicodePropertySupported ? '\\p{Ps}\\p{Pi}"\'' : '\\(\\[{"\'';
  var mentionCharacters = '\\S'; // The pattern consists of 3 groups:
  // - 0 (non-capturing): Opening sequence - start of the line, space or an opening punctuation character like "(" or "\"",
  // - 1: The marker character,
  // - 2: Mention input (taking the minimal length into consideration to trigger the UI),
  //
  // The pattern matches up to the caret (end of string switch - $).
  //               (0:      opening sequence       )(1:  marker   )(2:                typed mention                 )$

  var pattern = "(?:^|[ ".concat(openAfterCharacters, "])([").concat(marker, "])([").concat(mentionCharacters, "]").concat(numberOfCharacters, ")$");
  return new RegExp(pattern, 'u');
} // Creates a test callback for the marker to be used in the text watcher instance.
//
// @param {String} marker
// @param {Number} minimumCharacters
// @returns {Function}

function createTestCallback(marker, minimumCharacters) {
  var regExp = createRegExp(marker, minimumCharacters);
  return function (text) {
    return regExp.test(text);
  };
} // Creates a text matcher from the marker.
//
// @param {String} marker
// @returns {Function}


function requestFeedText(marker, text) {
  var regExp = createRegExp(marker, 0);
  var match = text.match(regExp);
  return match[2];
} // The default feed callback.


function createFeedCallback(feedItems) {
  return function (feedText) {
    var filteredItems = feedItems // Make the default mention feed case-insensitive.
    .filter(function (item) {
      // Item might be defined as object.
      var itemId = typeof item == 'string' ? item : String(item.id); // The default feed is case insensitive.

      return itemId.toLowerCase().includes(feedText.toLowerCase());
    }) // Do not return more than 10 items.
    .slice(0, 10);
    return filteredItems;
  };
} // Checks if a given key code is handled by the mention UI.
//
// @param {Number}
// @returns {Boolean}


function isHandledKey(keyCode) {
  return handledKeyCodes.includes(keyCode);
} // Checks if position in inside or right after a text with a mention.
//
// @param {module:engine/model/position~Position} position.
// @returns {Boolean}


function hasExistingMention(position) {
  // The text watcher listens only to changed range in selection - so the selection attributes are not yet available
  // and you cannot use selection.hasAttribute( 'mention' ) just yet.
  // See https://github.com/ckeditor/ckeditor5-engine/issues/1723.
  var hasMention = position.textNode && position.textNode.hasAttribute('mention');
  var nodeBefore = position.nodeBefore;
  return hasMention || nodeBefore && nodeBefore.is('$text') && nodeBefore.hasAttribute('mention');
} // Checks if string is a valid mention marker.
//
// @param {String} marker
// @returns {Boolean}


function isValidMentionMarker(marker) {
  return marker && marker.length == 1;
} // Checks the mention plugins is in completion mode (e.g. when typing is after a valid mention string like @foo).
//
// @returns {Boolean}


function checkIfStillInCompletionMode(editor) {
  return editor.model.markers.has('mention');
}